export const PDFStyle = {
	wrapper: {height: 'calc(100vh - 128px)', display: 'flex', flexDirection: 'column'},
	viewerBox: {flex: 1, overflow: 'hidden'},
	toolbarWrapper: {
		borderTop: '1px solid #eee',
		backgroundColor: '#fafafa',
		display: 'flex',
		justifyContent: 'center',
	},
	toolBarBox: {
		display: 'flex',
		gap: '12px',
		alignItems: 'center',
		mt: '16px',
		width: '100%',
		justifyContent: 'space-between',
		background: 'var(--default-white)',
		padding: '12px 24px',
		borderRadius: '8px',
	},
	toolBarMiddleBlock: {display: 'flex', alignItems: ' center', gap: '10px'},
};
